<!-- @format -->

<template>
	<div class="pc-bread-crumb">
		<div class="pc-bread-crumb-left">
			<template v-if="routeTitle.length > 1">
				<el-icon class="pc-bread-arrow" @click="onClickCrumb(routeTitle[routeTitle.length - 2])">
					<ArrowLeftBold />
				</el-icon>
			</template>
			<div class="pc-bread-crumb-title">
				<slot name="title">
					<template v-for="(item, idx) in routeTitle" :key="idx">
						<span v-if="idx !== 0" class="pc-bread-crumb-separator">/</span>
						<span
							:class="idx === routeTitle.length - 1 ? '' : 'pc-bread-crumb-label'"
							@click="idx === routeTitle.length - 1 ? () => {} : onClickCrumb(item)"
						>
							{{ item.label }}
						</span>
					</template>
				</slot>
			</div>
		</div>
		<slot name="extra"></slot>
	</div>
</template>

<script setup lang="ts">
	import { flatArr } from '@power/utils';
	import { useMenuStore } from '@/store/modules/menu';

	type CrumbList = { label: string; url: string }[];

	interface Props {
		crumbList?: CrumbList | ((c: CrumbList) => CrumbList);
	}

	const props = withDefaults(defineProps<Props>(), {});

	const emits = defineEmits(['click-crumb']);

	const menuStore = useMenuStore();

	const route = useRoute();

	const router = useRouter();

	const flatMenus = computed(() => {
		return flatArr(menuStore.displayMenus, 'children');
	});

	const getTitle = (name, paths: any = []) => {
		const item = flatMenus.value.find((item) => item.name === name);
		if (!item) {
			return paths;
		}
		paths.unshift({
			label: item.meta.title,
			url: item.fullPath,
		});
		if (item?.meta?.parentRoute) {
			getTitle(item.meta.parentRoute, paths);
		}
		return paths;
	};

	const routeTitle = computed(() => {
		if (route.query?.title) {
			return [{ label: route.query.title, url: '' }];
		}
		const crumbList = getTitle(route.name);
		return typeof props.crumbList === 'function' ? props.crumbList(crumbList) : props.crumbList || crumbList;
	});

	const onClickCrumb = (item) => {
		emits('click-crumb', item);
		if (item.url) {
			router.push(item.url);
		}
	};
</script>

<style scoped lang="scss">
	.pc-bread-crumb {
		height: 36px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		cursor: pointer;

		.pc-bread-arrow {
			font-size: 20px;
		}

		.pc-bread-crumb-left {
			display: flex;
			align-items: center;
			flex: 1;
		}

		.pc-bread-crumb-title {
			font-size: 20px;
			color: var(--theme-text-color-title);
			font-weight: 600;
			font-family: PingFangSC-Medium;
			line-height: 36px;
			letter-spacing: 0;
			display: flex;
		}

		.pc-bread-crumb-separator {
			font-size: 12px;
			margin: 0 6px;
			font-weight: normal;
			color: var(--theme-text-color-disabled);
		}

		.pc-bread-crumb-label {
			display: flex;
			align-items: center;
		}
	}
</style>
